import httpApi from '@vue3/utils/http-api'
import { api } from '@vue3/configs'

export default {
  saveToken: (body) => {
    return httpApi.postDataViaApi({
      url: api.notification.saveToken,
      body
    })
  },
  deleteToken: (body) => {
    return httpApi.deleteDataViaApi({
      url: api.notification.deleteToken,
      body
    })
  },
  updateTime: (body) => {
    return httpApi.postDataViaApi({
      url: api.notification.updateTime,
      body
    })
  },
  getNotifications: (queryParams) => {
    return httpApi.getDataViaApi({
      url: api.notification.getNotifications,
      queryParams
    })
  },
  markAsRead: (body) => {
    return httpApi.putDataViaApi({
      url: api.notification.markAsRead,
      body
    })
  }
}
